/**
 * @file SegToggle.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-29
 * @modified 2026-09-29
 * @description A small segmented choice — "T | pack", "pallet | tonne | load"
 *              — compact enough to sit in a table cell. Used by the import
 *              reviews for their per-row unit assumptions and bulk bars.
 *              value null shows nothing chosen (a bulk bar's "set all to").
 */

import React from 'react';
import './ImportReview.css';

function SegToggle({ value, options, onChange, title, disabled = false }) {
  return (
    <span className="seg-toggle" title={title}>
      {options.map(o => (
        <button
          key={o.value}
          type="button"
          className={value === o.value ? 'on' : ''}
          disabled={disabled}
          onClick={(e) => { e.stopPropagation(); onChange(o.value); }}
        >
          {o.label}
        </button>
      ))}
    </span>
  );
}

export default SegToggle;
